/* eslint-disable max-len */
const ThumbsDownSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M13.067 4h-.02c-.636.007-1.274.007-1.911.007h-.973c-.649 0-1.298 0-1.95.008-.36.01-.715.085-1.05.222-.57.221-.894.715-.892 1.357l.001 2.408c0 1.333 0 2.668.012 4.002.002.363.236.703.436.882.774.705 1.615 1.584 1.967 2.769.097.33.135.695.174 1.08C8.94 17.5 9.44 18 10.105 18c.262 0 .523-.078.78-.23.514-.308.858-.792 1.047-1.481.304-1.095.149-2.158-.022-3.07v-.003a.346.346 0 01.34-.41h2.222c.382 0 .931-.048 1.27-.456.245-.298.316-.7.211-1.232-.318-1.633-.707-3.28-1.08-4.814-.116-.478-.31-.921-.495-1.35l-.08-.184c-.213-.498-.65-.77-1.231-.77zm-9.527.16h-.204C2.602 4.16 2 4.76 2 5.492v5.935c0 .732.602 1.331 1.336 1.331h.204c.735 0 1.336-.6 1.336-1.331V5.493A1.336 1.336 0 003.54 4.16z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default ThumbsDownSvg;
